// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.star-rating[data-v-efabe160] {\n    display: inline-block;\n    font-size: 0;\n}\n.star[data-v-efabe160] {\n    font-size: 0;\n    cursor: pointer;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
